import { Box, Typography, styled } from '@material-ui/core';

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  padding: theme.spacing(1, 3),
  maxWidth: 500
}));

export const Row = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 12,
  marginTop: 18
});

export const IconBox = styled(Box)({
  borderRadius: 8,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0
});

export const TextContainer = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: 4
});

export const Title = styled(Typography)({
  fontSize: 14,
  fontWeight: 600,
  color: '#333D47'
});

export const Description = styled(Typography)({
  fontSize: 12,
  color: '#5D7083'
});

export const CheckboxRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 8,
  marginTop: 8
});

export const CheckboxLabel = styled(Typography)({
  fontSize: 14,
  color: '#333D47'
});

export const Footer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
});
